var l = { icon: { tag: "svg", attrs: { viewBox: "0 0 16 16", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M12.54 8.18H9.99V.47c0-.25-.3-.45-.67-.45H6.66C6.3.02 6 .22 6 .47v7.71H3.45c-.36 0-.57.4-.37.7l4.54 6.9a.45.45 0 00.75 0l4.54-6.9c.2-.3-.02-.7-.37-.7z", "fill-rule": "nonzero" } }] }, name: "arrow-down", theme: "filled" };
export {
  l as default
};
